import { render, staticRenderFns } from "./publishSettings.vue?vue&type=template&id=7321295c"
import script from "./publishSettings.vue?vue&type=script&lang=js"
export * from "./publishSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports